import yxpapi from '@yxpapi';

let apis = new yxpapi.PHPAPI({
    // 机型列表
    getProductList: {
        url: 'https://youxueketang.anoah.com/api/crm/website/official/product/machine-list',
        // url: 'http://yapi.dev.anoah.com/mock/1240/crm/website/official/product/machine-list',
        method: 'get',
        options: {
            auth: false,
        },
    },
    // 获取轮播图
    getTotate: {
        url: 'https://youxueketang.anoah.com/api/crm/website/official/product/top-image',
        // url: 'http://yapi.dev.anoah.com/mock/1240/crm/website/official/product/top-image',
        method: 'get',
        options: {
            auth: false,
        },
    },
    getPCCarousel: {
        url: '/api/crm/rotation/list',
        method: 'get',
        options: {
            auth: false,
            headers: {
                orgid: 1,
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
            },
        },
    },
    getMobileCarousel: {
        url: '/api/crm/catalog/rotation/catalogList',
        method: 'get',
        options: {
            auth: false,
            headers: {
                orgid: 1,
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
            },
        },
    },
});
export default apis;
